import Dropdown, { MultiDropdown } from "@components/form/Dropdown.component";
import { usePipelineNode } from "@stores/data.store";
import { useMemo } from "react";

interface Props {
    pipelineNodeId: string;
    onSelect: (fieldId: string) => any;
    selectedId?: string;
    disabled?: boolean;
}

const PipelineNodeColumnSelector = (props: Props) => {
    const pipelineNode = usePipelineNode(props.pipelineNodeId);

    const columnOptions = useMemo(() => {
        if (!pipelineNode.data) {
            return [];
        }

        return pipelineNode.data.fields.map(f => {
            return {
                value: f.id,
                label: f.name,
            }
        });
    }, [pipelineNode.dataUpdatedAt]);

    return <Dropdown
        disabled={!props.pipelineNodeId || !!props.disabled}
        selected={props.selectedId}
        options={columnOptions}
        onChange={props.onSelect}
    />
}

export default PipelineNodeColumnSelector;

interface MultiProps {
    pipelineNodeId: string;
    onSelect: (fieldIds: string[]) => any;
    selectedIds: string[];
    disabled?: boolean;
}
export const PipelineNodeMultiColumnSelector = (props: MultiProps) => {
    const pipelineNode = usePipelineNode(props.pipelineNodeId);

    const columnOptions = useMemo(() => {
        if (!pipelineNode.data) {
            return [];
        }

        return pipelineNode.data.fields.map(f => {
            return {
                value: f.id,
                label: f.name,
            }
        });
    }, [pipelineNode.dataUpdatedAt]);

    return <MultiDropdown
        disabled={!props.pipelineNodeId || !!props.disabled}
        selected={props.selectedIds}
        options={columnOptions}
        onChange={props.onSelect}
    />
}